import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { getDriversAvatarsBulk } from '../../services/DriversService';
import { DriverAvatar, DriversAvatarRequest } from '../../types/Drivers';

type Result = UseMutationResult<DriverAvatar[], Error, DriversAvatarRequest>;

function useGetDriversAvatarsBulk(successCb: (data: DriverAvatar[]) => void, failureCb: (error: string) => void): Result {
  return useMutation(getDriversAvatarsBulk, {
    onSuccess: (data: DriverAvatar[]) => {
      successCb(data);
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useGetDriversAvatarsBulk;
